import angular from 'angular'

import { rollTypeInvoice, invoice, ovatBill } from 'redevConfig'
const add = (rollTypeInvoice && rollTypeInvoice.add) || ''
const list = (invoice && invoice.list) || ''
const relatedBill = (invoice && invoice.relatedBill) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''

const addPage = add ? require(`redevelopment/outputManage/rollTypeInvoice/${add.templateName}`) : require('./view/add.html')
const addCtrl = add ? require(`redevelopment/outputManage/rollTypeInvoice/${add.controllerName}`) : require('./add')
const listPage = list ? require(`redevelopment/outputManage/invoice/${list.templateName}`) : require('../invoice1/view/invoiceList.html')
const listCtrl = list ? require(`redevelopment/outputManage/invoice/${list.controllerName}`) : require('../invoice1/InvoiceListCtrl')
const relatedBillPage = relatedBill ? require(`redevelopment/outputManage/invoice/${relatedBill.templateName}`) : require('../invoice1/view/relatedBill_invoice.html')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../ovatBill/view/checkBillDetailCtrl.html')

function configRouter ($stateProvider) {
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice',
        {
            url: '/rollTypeInvoice',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'outputManage.FOManage.rollTypeInvoice.list',
            title: '卷票开具',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.list',
        {
            url: '/list',
            template: listPage,
            controller: 'rollTypeInvoiceListCtrl',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.detail',
        {
            url: '/detail/:waitId',
            template: addPage,
            controller: 'rollTypeInvoiceAdd',
            title: '卷票详情',
            params: {
                detailFlag: true,
            },
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.edit',
        {
            url: '/eidt/:waitId',
            template: addPage,
            controller: 'rollTypeInvoiceAdd',
            title: '编辑卷票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.add',
        {
            url: '/add/:invType',
            template: addPage,
            controller: 'rollTypeInvoiceAdd',
            title: '新增卷票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.addred',
        {
            url: '/addred/:invType',
            template: addPage,
            controller: 'rollTypeInvoiceAdd',
            title: '新增红字卷票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.relatedBill',
        {
            url: '/relatedBill/:waitId',
            template: relatedBillPage,
            controller: 'invRelatedBillCtrl',
            title: '卷票销售单',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.rollTypeInvoice.checkBillDetail',
        {
            url: '/checkBillDetail/:billId',
            template: checkBillDetailCtrl,
            controller: 'checkBillDetailCtrl',
            title: '销售单明细',
        },
    )
}

export default angular
    .module('outputManage.FOManage.rollTypeInvoice', [])
    .config(['$stateProvider', configRouter])
    .controller('rollTypeInvoiceListCtrl', listCtrl.default)
    .controller('rollTypeInvoiceAdd', addCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/rollTypeInvoice/index.js